import React from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import '../TextEditor/style.css';
import { useSelector } from 'react-redux';
import {isEmpty,isUndefined} from 'lodash'

function EditIndexJ(props) {
    const userList = useSelector(state=>state.accountsData.Userlista)
    const [suggestions, setSuggestions] = React.useState([])
    const [editorState, setEditorState] = React.useState(
        EditorState.createEmpty()
    );
    React.useEffect(()=>{
        if(!isEmpty(userList)){
            let Suggest = []
            userList.filter(item=>parseInt(item.Token) === 1).map(item=>{
                Suggest.push({
                    text:`${item.FirstName} ${item.LastName}`,
                    value:`${item.FirstName} ${item.LastName}`,
                    url:`mention_userid:${item.id}`
                })
            })
            setSuggestions(Suggest)
        }
    },[userList])   
    React.useEffect(()=>{
        if(!isEmpty(props.commentText)){
        const contentBlock =  htmlToDraft(props.commentText)
        if (contentBlock) {
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            const editorState = EditorState.createWithContent(contentState);
            setEditorState(editorState)
        }        
        }
        if(!isUndefined(props.onsetisEdited)){
            props.onsetisEdited()
        }        
    },[props.isEdited])
    React.useEffect(()=>{
        if(isEmpty(props.commentText)){
            setEditorState( EditorState.createEmpty())
        }
    },[props.commentText])
    const onEditorStateChange = (editorState) => {
				console.log(editorState, 'editorState')
        setEditorState(editorState)
        const contentState = editorState.getCurrentContent();
        props.handleupdatecommentText(draftToHtml(convertToRaw(contentState)))
    };
   
    const getContentAsHTML = () => {
        const contentState = editorState.getCurrentContent();
        return draftToHtml(convertToRaw(contentState));
    };
    const editorStyle = {
        height:isUndefined(props.height) ? "250px" : 'calc(100vh - 180px)',
        padding: '10px',
        border: '1px solid #F1F1F1',
        borderRadius: '2px',
        overflowY: 'auto',
      };
    return (
        <div>
              <Editor
        editorState={editorState}
        toolbarClassName="toolbarClassName"
        wrapperClassName="wrapperClassName"
        editorClassName="editorClassName"
        onEditorStateChange={onEditorStateChange}
        editorStyle={editorStyle}
        readOnly={props.disabled}
        placeholder={isUndefined(props.placeHolder)?"":props.placeHolder}
       
       mention={{
            separator: ' ',
            trigger: '@',
            suggestions: suggestions,
          }}
        toolbar={{
            options: ['inline', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'remove', 'history'],
            inline: { inDropdown: true },
            list: { inDropdown: true },
            textAlign: { inDropdown: true },
            link: { inDropdown: true },
            history: { inDropdown: true },
        }}
        />
        </div>
    );
}

export default EditIndexJ;